import React from 'react';
import PropTypes from 'prop-types';

const NumberInput = ({ inputValue, onChange, onKeyPress, label }) => {
    return (
        <div className="filter-item">
            <label htmlFor={label} >{label}:</label>
            <div>
                <input
                    className="number-input"
                    type="number"
                    id={`${label.toLowerCase()}-number-input`}
                    value={inputValue}
                    onChange={onChange}
                    onKeyPress={onKeyPress}
                    min={0}
                    step={1}
                />
            </div>
        </div>
    );
};

NumberInput.propTypes = {
    inputValue: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    onKeyPress: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
};

export default NumberInput;
